var map = {
	"./Carousel Image 1.png": 828,
	"./Carousel Image 2.png": 829,
	"./Carousel Image 3.png": 830,
	"./Carousel Image 4.png": 831,
	"./Carousel Image 5.png": 832,
	"./Carousel Image 6.png": 833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 827;